import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.REACT_APP_URL_API;

class UserService {
  getPublicContent() {
    return axios.get(API_URL + 'users');
  }

  getAllUser() {
    return axios.get(API_URL + 'users_role', { headers: authHeader() });
  }

  register(username, email, password, roles, service) {
    return axios.post(API_URL + "users", {
      username,
      email,
      password,
      roles,
      service
    },{ headers: authHeader() });
  }

  getUser(userId){
    return axios.get(API_URL + 'users/' + userId, { headers: authHeader() });
  }

  getModeratorBoard() {
    return axios.get(API_URL + 'mod', { headers: authHeader() });
  }

  deleteUser(userid){
    return axios.delete(API_URL + "users/" + userid, { headers: authHeader() });
  }

  updateUser(userid, username, email, password, roles,service){
    return axios.put(API_URL + "users/" + userid, {
      username,
      email,
      password,
      roles,
      service
    },{ headers: authHeader() });
  }

}

export default new UserService();
